module.exports = __webpack_public_path__ + "static/media/image2.683b5704.jpg";